<div class="notifications-page">
  <div class="notifications-container">
    <app-h1-heading
      [classContainer]="'flex items-center justify-between w-full border-b border-gray-200'"
      [class]="'heading-section'"
      heading="Notifications"
    >
    </app-h1-heading>
    <!-- Filter Bar -->
    <div class="filter-bar">
      <div class="tabs-group">
        <div class="tab" [class.active]="activeTab === 'All'" (click)="changeTab('All')">
          All
          <span class="badge red">{{ allCount }}</span>
        </div>
        <div class="tab" [class.active]="activeTab === 'Alerts'" (click)="changeTab('Alerts')">
          Alerts
          <span class="badge red">{{ alertCount }}</span>
        </div>
        <div class="tab" [class.active]="activeTab === 'Messages'" (click)="changeTab('Messages')">
          Messages
          <span class="badge red">{{ messageCount }}</span>
        </div>
      </div>
      @if(hasUnreadNotifications){<button class="mark-all-btn" (click)="markAllAsRead()">
          <img src="assets/mark-all-as-read.svg" alt="Mark all" class="mark-icon" />
          Mark all as read.
        </button>}
    </div>

    <!-- Notification Items -->
    <div class="notifications-list">
      @if (isLoading) {
        <app-content-skeleton variant="list" [listLines]="8" ariaLabel="Loading notifications" />
      } @else {
        @for (note of pagedNotifications; track note.id) {
          <div
            class="notification-card"
            (click)="selectNotification(note)"
            [class.read]="note.status === 'read'"
          >
            <div
              class="bell-icon"
              [ngClass]="{
                'info-bell': note.type === 'Information',
                'alert-bell': note.type === 'Alert',
                'message-bell': note.type === 'Message',
              }"
            >
              <img src="assets/notifications.svg" alt="Notification" class="bell-img" />
            </div>

            <div class="notification-content">
              <p class="notification-title">{{ note.message }}</p>
              <div class="notification-meta">
                <span class="time">{{ note.date }}</span>
                <span class="separator">|</span>
                <span class="sender">{{ note.sender || 'Admin' }}</span>
                <span
                  class="type-badge"
                  [ngClass]="{
                    'badge-info': note.type === 'Information',
                    'badge-alert': note.type === 'Alert',
                    'badge-message': note.type === 'Message',
                  }"
                >
                  {{ note.type }}
                </span>
              </div>
            </div>

            <div class="action-icons" (click)="$event.stopPropagation()">
              <button class="icon-btn" (click)="markAsRead(note.id, $event)" *ngIf="note.status === 'unread'" title="Mark as read">
                <span class="icon-wrapper">
                  <img src="assets/icons/View-icon-idle-state.svg" alt="Mark as read" class="icon-idle" />
                  <img src="assets/icons/View-icon-pressed-state.svg" alt="" class="icon-pressed" aria-hidden="true" />
                </span>
              </button>
              <button class="icon-btn" (click)="openDeleteConfirm(note.id, $event)" title="Delete">
                <span class="icon-wrapper">
                  <img src="assets/icons/Delete-icon-idle-state.svg" alt="Delete" class="icon-idle" />
                  <img src="assets/icons/Delete-icon-pressed-state.svg" alt="" class="icon-pressed" aria-hidden="true" />
                </span>
              </button>
            </div>
          </div>
        }
        @if (pagedNotifications.length === 0) {
          <div class="empty-state">No notifications found.</div>
        }
      }
    </div>

    <!-- Pagination -->
    @if (totalPages > 1) {
      <div class="pagination">
        <button
          class="pagination-btn"
          (click)="onPageChange(currentPage - 1)"
          [disabled]="!hasPrevious"
          type="button"
        >
          Previous
        </button>
        <span class="pagination-info">
          Page {{ currentPage }} of {{ totalPages }}
          @if (totalCount > 0) {
            <span class="pagination-count">
              (Showing {{ getStartIndex() }} - {{ getEndIndex() }} of {{ totalCount }})
            </span>
          }
        </span>
        <button
          class="pagination-btn"
          (click)="onPageChange(currentPage + 1)"
          [disabled]="!hasNext"
          type="button"
        >
          Next
        </button>
      </div>
    }
  </div>

  <!-- Delete Confirmation Popup -->
  <div
    *ngIf="deleteConfirmId !== null"
    class="delete-confirm-backdrop"
    (click)="closeDeleteConfirm()"
  >
    <div class="delete-confirm-popup" (click)="$event.stopPropagation()">
      <p class="delete-confirm-message">Are you sure you want to delete this notification?</p>
      <div class="delete-confirm-actions">
        <button class="delete-confirm-btn delete-confirm-yes" (click)="confirmDelete()">Yes</button>
        <button class="delete-confirm-btn delete-confirm-no" (click)="closeDeleteConfirm()">No</button>
      </div>
    </div>
  </div>
</div>
